module.exports = __webpack_public_path__ + "img/devops.3d5aac72.png";